import React from 'react'
import { AppSvg, FormattedHTMLMessage, IconWithBackground, NavMenuItem, newIcons } from '@web/walter-ui-kit'

import s from './style.module.css'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import { useCommonCMSConfig } from '~api'
import { lang } from '~components/App/Layout/NavigationMenu/lang'

interface Props {
    isIcon?: boolean
}

function ReferralButton({ isIcon }: Props) {
    const { features = {} } = useCommonCMSConfig().data ?? {}
    const { show: openReferralModal } = useModal(ModalTypes.referral)

    if (!features.showReferral) {
        return null
    }

    if (isIcon) {
        return (
            <div onClick={() => openReferralModal()} className={s.iconButton} data-pointer="referral_button">
                <IconWithBackground
                    size={40}
                    type="default"
                    icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Gift} />}
                />
            </div>
        )
    }

    return (
        <NavMenuItem
            icon={<AppSvg path="new-icons" svgName={newIcons.ic24PlusCircle} size={24} />}
            type="button"
            onClick={() => openReferralModal()}
            dataPointer="referral_button"
        >
            <FormattedHTMLMessage {...lang.invite} />
        </NavMenuItem>
    )
}

export default ReferralButton
